export default __webpack_public_path__ + "static/announcement-header-04b106e13b26199142dece50135562a6.png";